<template>
  <div class="container">
    <HeaderView />
    <div
      :class="{
        'bg-content': $store.state.screenWidth > 375,
        'bg-content-se': $store.state.screenWidth <= 375,
        'bg-content-4': $store.state.screenWidth <= 320,
      }"
    >
      <div class="container" style="padding-bottom: 80px;">
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-4">
            <h2
              :class="{
                'mt-2 mb-3': $store.state.screenWidth > 375,
                'mt-3 mb-3': $store.state.screenWidth <= 375,
              }"
              style="font-family: 'Mitr', sans-serif; font-size: 30px;"
            >
              <i class="ti ti-user-search"></i>
              &nbsp;ข้อมูลส่วนตัว
            </h2>
            <form
              id="formprofile"
              class="needs-validation mb-3"
              novalidate
              autocomplete="off"
            >
              <label class="mb-2 fw-bold">รหัสบัตรประชาชนหรือเลขพาสปอร์ต</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="citizen_id"
                autocomplete="off"
                required
                readonly
              />
              <label class="mb-2 fw-bold">ชื่อ - นามสกุล</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="fullname"
                autocomplete="off"
                required
              />
              <label class="mb-2 fw-bold">เบอร์โทรศัพท์</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="tel"
                v-mask="'###-###-####'"
                autocomplete="off"
                required
              />
              <label class="mb-2 fw-bold">อีเมล</label>
              <input
                class="form-control mb-2"
                style="font-family: 'Mitr', sans-serif;"
                type="email"
                v-model="email"
                autocomplete="off"
                required
              />
              <label class="mb-2 fw-bold">สถานศึกษาปัจจุบัน</label>
              <vue-bootstrap-typeahead
                class="mb-2"
                style="font-family: 'Mitr', sans-serif;"
                inputClass="form-control"
                ref="school"
                v-model="school"
                :data="school_lists"
              />
              <label class="mb-2 fw-bold">คณะที่สนใจ</label>
              <select
                class="form-select mb-2"
                v-model="facId"
                style="font-family: 'Mitr', sans-serif;"
                required
              >
                <option value="" disabled hidden>
                  กรุณาเลือกคณะที่สนใจ...
                </option>
                <option
                  v-for="(cp, i) in fac_list"
                  :key="'rcf' + i"
                  :value="cp.id"
                >
                  {{ cp.name }}
                </option>
              </select>
              <label class="mb-2 fw-bold">หลักสูตรที่สนใจ</label>
              <textarea
                class="form-control mb-2"
                rows="2"
                style="font-family: 'Mitr', sans-serif;"
                type="text"
                v-model="depName"
                autocomplete="off"
              />
            </form>
            <div class="d-flex justify-content-between align-items-center">
              <button
                class="btn bg-rmutl text-white"
                style="
                  width: 48%;
                  font-size: 22px;
                  font-family: 'Mitr', sans-serif;
                "
                @click="validateForm"
              >
                <i class="ti ti-device-floppy"></i>
                &nbsp;บันทึก
              </button>
              <button
                class="btn bg-ligth"
                style="
                  width: 48%;
                  font-size: 22px;
                  font-family: 'Mitr', sans-serif;
                "
                @click="$router.push('/activity')"
              >
                <i class="ti ti-chevron-left"></i>
                &nbsp;ย้อนกลับ
              </button>
            </div>
            <button
              class="btn bg-danger mt-3"
              style="
                width: 100%;
                font-size: 22px;
                font-family: 'Mitr', sans-serif;
              "
              @click="logout"
            >
              <i class="ti ti-logout"></i>
              &nbsp;ออกจากระบบ
            </button>
          </div>
          <div class="col-sm-4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import Swal from 'sweetalert2'
import api from '../assets/services'
import $ from 'jquery'

export default {
  components: {
    HeaderView,
    VueBootstrapTypeahead,
  },
  data() {
    return {
      school_lists: [],
      citizen_id: '',
      fullname: '',
      tel: '',
      email: '',
      school: '',
      facId: '',
      fac_list: [
        { id: 1, name: 'คณะบริหารธุรกิจและศิลปศาสตร์' },
        { id: 2, name: 'คณะวิทยาศาสตร์และเทคโนโลยีการเกษตร' },
        { id: 3, name: 'คณะวิศวกรรมศาสตร์' },
        { id: 4, name: 'คณะศิลปกรรมและสถาปัตยกรรมศาสตร์' },
        { id: 5, name: 'วิทยาลัยเทคโนโลยีและสหวิทยาการ' },
      ],
      depName: '',
    }
  },
  watch: {
    '$store.state.user': {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.citizen_id = newValue.citizenId
        this.fullname = newValue.fullname
        this.tel = newValue.tel
        this.email = newValue.email
        this.school = newValue.school
        this.facId = newValue.facId
        this.depName = newValue.depName
      },
    },
  },
  methods: {
    validateForm() {
      const $myForm = $('#formprofile')
      if (!$myForm[0].checkValidity()) {
        $('#formprofile').addClass('was-validated')
      } else {
        $('#formprofile').removeClass('was-validated')
        this.editProfile()
      }
    },
    logout() {
      localStorage.clear()
      this.$router.push('/').catch(() => {})
    },
    editProfile() {
      this.$store.state.isLoading = true
      api.updateProfile(
        this.$store.state.URL,
        {
          fullname: this.fullname,
          tel: this.tel,
          email: this.email,
          school: this.school,
          facId: this.facId,
          depName: this.depName,
        },
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'success',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'ตกลง',
            }).then((result) => {
              this.$router.push('/activity').catch(() => {})
              this.$store.state.isLoading = false
            })
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => {})
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => {})
        },
      )
    },
    getSchools() {
      this.$store.state.isLoading = true
      api.schoolData(
        this.$store.state.URL,
        this.header,
        (result) => {
          if (result.status === 'SUCCESS') {
            this.$store.state.isLoading = false
            this.school_lists = []
            result.data.forEach((v) => {
              this.school_lists.push(v['school_name'])
            })
            this.$refs.school.inputValue = this.school
          } else {
            this.$store.state.isLoading = false
            Swal.fire({
              title: 'ตรวจสอบ',
              text: result.message,
              icon: 'warning',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'เข้าสู่ระบบใหม่',
              denyButtonText: 'ยกเลิก',
            }).then((result) => {
              localStorage.clear()
              this.$router.push('/').catch(() => {})
            })
          }
        },
        (_error) => {
          this.$store.state.isLoading = false
          localStorage.clear()
          this.$router.push('/').catch(() => {})
        },
      )
    },
  },
  mounted() {
    const auth = this.callbackToken(this.$store.state.user.citizenId)
    if (auth) {
      this.getProfile()
      this.getSchools()
    } else {
      localStorage.clear()
      this.$router.push('/').catch(() => {})
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Profile.vue